import { http } from '~/stores/transport/http';

export const useOneSignalID = () => {
  const init = () => {
    const pushExternalId = window.location.href.match(/pushExternalId=([\w-]+(_[\d\w]+)?)/)?.[1];

    if (pushExternalId) {
      localStorage.setItem('pushExternalId', pushExternalId);
    }

    const mode = window.location.href.match(/mode=([\w-]+(_[\d\w]+)?)/)?.[1];

    if (mode === 'pwa') {
      localStorage.setItem('isPwa', '1');
    }
  };

  return {
    init,
    getPushId: () => localStorage.getItem('pushExternalId'),

    setUserGroup: (tags: string | Record<string, string>) => {
      const tagsData = typeof tags === 'string' ? { [tags]: 'true' } : tags;
      if (localStorage.getItem('pushExternalId')) {
        http().post(null, {
          // host: 'dev.7bitcasino.com',
          url: '/api/onesignal/update_user_by_external_id',
          force: true,
          payload: {
            userExternalId: localStorage.getItem('pushExternalId'),
            data: {
              properties: {
                tags: tagsData,
              },
            },
          },
        } as any);
      }
    },
  };
};
